import { cn } from '@utils/cn';
import { TabsProps, TabOption } from './types';
import { useTranslation } from 'react-i18next';
import { Key } from 'react';

export const Tabs = <T extends string>({
  value,
  setValue,
  options,
  disabled,
  size = 'lg',
  fullWidth,
  stretch,
  withTranslation = false,
}: TabsProps<T>) => {
  const { t } = useTranslation('app', { keyPrefix: 'tabs' });

  return (
    <nav className={cn('tabs', fullWidth || stretch ? 'w-full' : 'w-fit')}>
      <ul className="flex">
        {options.map((el) => {
          const elementValue = withTranslation ? (el as TabOption).value : el;
          const elementName = withTranslation
            ? (el as TabOption).name
            : t(el as string).includes('.')
              ? el
              : t(el as string);

          return (
            <li key={elementValue as Key} className={stretch ? 'min-w-0 flex-1' : 'min-w-fit'}>
              <button
                type="button"
                key={`tabs-option-${el}`}
                className={cn([
                  'select-none border-b-2 px-6 py-2 font-bold text-neutral-700 disabled:text-opacity-30',
                  size === 'sm' ? 'text-xs' : 'text-m',
                  stretch && 'w-full px-2',
                  elementValue === value &&
                    'border-primary-400 text-primary-400 disabled:text-opacity-100',
                  disabled && 'cursor-not-allowed',
                ])}
                disabled={el === value || disabled}
                onClick={() => setValue(elementValue as T)}>
                {elementName as string}
              </button>
            </li>
          );
        })}
        {fullWidth && <li className="border-b-2 w-full" />}
      </ul>
    </nav>
  );
};
